'use client';
import React, { useCallback } from 'react';
import { Watchlist } from '@benzinga/watchlist-manager';
import styled from '@benzinga/themetron';
import dynamic from 'next/dynamic';

const Select = dynamic(() => import('react-select'), {
  loading: () => <SelectSkeleton />,
  ssr: false,
}) as unknown as typeof import('react-select').default;

export interface WatchlistSelectProps {
  onClear?: () => void;
  onSelect: (watchlist: Watchlist) => void;
  watchlist: Watchlist | null;
  watchlists?: Watchlist[];
}

export const WatchlistSelect = ({ onClear, onSelect, watchlist, watchlists }: WatchlistSelectProps) => {
  const selectedItem = useCallback(
    (value: any) => {
      if (value === 'all') {
        onClear && onClear();
      } else {
        onSelect(value);
      }
    },
    [onClear, onSelect],
  );

  if (!watchlists) {
    return <LoadingBox className="loading-box">Loading Watchlists...</LoadingBox>;
  }

  return (
    <WatchlistSelectWrapper className="watchlist-select">
      <Select
        getOptionLabel={(item: any) => item.name}
        getOptionValue={(item: any) => item.watchlistId}
        isClearable={onClear ? true : false}
        isSearchable={false}
        onChange={selectedItem}
        options={watchlists}
        placeholder={onClear ? 'All Watchlists' : 'Select Watchlist'}
        value={watchlist}
      />
    </WatchlistSelectWrapper>
  );
};

const SelectSkeleton = styled.div`
  min-height: 38px;
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 4px;
  background: #fff;
`;

export const LoadingBox = styled.div`
  &.loading-box {
    background-color: ${props => props.theme.colorPalette.neutral50};
    border: solid 1px ${props => props.theme.colorPalette.gray200};
    border-radius: 4px;
    color: #a9a9a9;
    margin-bottom: 8px;
    padding: 8px;
    width: 100%;
  }
`;

export const WatchlistSelectWrapper = styled.div`
  &.watchlist-select {
    width: 100%;
    margin-bottom: 12px;
  }
`;
